import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { Property, SaleType } from 'src/app/models/property/property';
import { webPageCity } from 'src/app/web-page-city.data';
import { ActivatedRoute } from '@angular/router';
import { AppPageService } from 'src/app/core/ui/document-title/app-page.service';
import { Title, Meta } from '@angular/platform-browser';
import { WebPageCityService } from '../services/web-page-city.service'
import { ResponsiveService } from 'src/app/core/ui/responsive/responsive.service';
import { PropertySearchingService } from '../../property-search/services/property-searching.service'
import { PlatformService } from 'src/app/core/platform/platform.service';

@Component({
  selector: 'app-web-page-city',
  templateUrl: './web-page-city.component.html',
  styleUrls: ['./web-page-city.component.css'],
  providers: [],
  encapsulation: ViewEncapsulation.None,
})
export class WebPageCityComponent extends AppPageService implements OnInit {
  @ViewChild('propertiesSection') propertiesSection: ElementRef | undefined;
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected titleService: Title,
    private webPageCityService: WebPageCityService,
    private propertySearchingService: PropertySearchingService,
    private metaService: Meta,
    private responsiveService: ResponsiveService,
    private platformService: PlatformService
  ) {
    super(titleService, activatedRoute);
  }

  ngOnInit(): void {
    const doc = this.responsiveService.getDocument()//TODO: change here
    if (doc && doc.scrollingElement) {
      doc.scrollingElement.scrollTop = 0;
    }
    this.city_id = this.activatedRoute.snapshot.data.city_id;
    this.url_name = this.activatedRoute.snapshot.url[0].path;
    this.getPropertySearches();
    this.getWebPageCity();

  }
  city_id: number = 0;
  url_name: string = '';
  pageContent: string = ``
  pageTitle: string = ''
  pageName: string = ''
  propertyByCities: { url_name: string, page_title: string }[] = webPageCity;
  properties: Property[] = [];
  totalProperties: Property[] = [];

  private getWebPageCity() {
    if (this.platformService.isPlatformBrowser) {
      this.webPageCityService.getWebPageCity({ city_id: this.city_id, url_name: this.url_name }).subscribe((result) => {
        result.data.map((element: any) => {
          this.pageName = element.page_name ? element.page_name : '';
          this.pageTitle = element.page_title ? element.page_title : '';
          this.pageContent = element.page_content ? element.page_content : '';
          this.titleService.setTitle(element.meta_title);
          this.metaService.updateTag(
            { name: 'description', content: `${element.meta_description}` }
          );
          this.metaService.updateTag(
            { name: 'keywords', content: `${element.meta_keywords}` }
          );
        });
        // this.properties = this.totalProperties.slice(0,6);
        // console.log(this.properties);
      });
    }
  }

  private getPropertySearches() {
    if (this.platformService.isPlatformBrowser) {
      this.propertySearchingService.getPropertySearchs({ is_search: 1, city_id: this.city_id, status: 1 }).subscribe((result) => {
        if (result.data.resultData) {
          this.properties = result.data.resultData.map((element: any) => {
            let thumbImg = element.PropertyImages[0];
            // console.log(element.address);
            element.PropertyImages.map((ele: any, i: number) => {
              if (ele.isThumb == 1) {
                thumbImg = ele;
              }
            });
            const details = {
              id: `${element.id}`,
              createdAt: new Date(`${element.createdAt}`).toISOString(),
              propertyType: (element.mode == 1) ? SaleType.ForSale : (element.mode == 2) ? SaleType.ForRent : (element.mode == 3) ? SaleType.ForRentAndSale : (element.mode == 4) ? SaleType.Deposite : SaleType.Deposite,
              title: element.place,
              price: (element.mode == 1) ? element.amount : (element.mode == 2) ? element.rent : (element.mode == 3) ? element.rent : (element.mode == 4) ? element.deposit : element.deposit,
              address: element.address,
              noOfBeds: element.PropertyBed ? element.PropertyBed.quantity : null,
              residenceType: element.PropertyType ? element.PropertyType.name : '',
              areaInSquareFt: element.area,
              noOfBaths: element.PropertyBath ? element.PropertyBath.quantity : null,
              image: `https://northbloomfield.s3.us-east-2.amazonaws.com/${thumbImg?.smallPath}`,
              // image: 'https://www.northbloomfield.com/img/main_images/small/991523175514169472.JPG',
              city: element.City ? element.City.name : '',
              place: element.place,
            };
            return new Property(
              details.id, details.createdAt, details.propertyType, details.title, details.price, details.address, details.noOfBeds, details.residenceType, details.areaInSquareFt, details.noOfBaths, details.image, details.city, details.place
            );
          });
        }
      });
    }
  }
  //code for loadmore future use
  // @HostListener('window:scroll', ['$event'])
  //   scrollHandler(event:any) {
  //     if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
  //       if(this.properties.length <= this.totalProperties.length){
  //         this.properties = [...this.properties,...this.totalProperties.slice(6,12)]
  //         console.log(this.properties.length)
  //       }

  //     }
  //   }
}
